module.exports = __webpack_public_path__ + "img/no-image.0967be46.jpg";